import {Payload} from '~/ViewInvitation/common/RSVPModalVariantAB/types';
import {RSVPModalContent} from '~/ViewInvitation/common/RSVPModal';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';

type RSVPModalVariantABContentProps = {
  status: string;
  onClickClose: () => void;
  onCtaClick: (payload: Payload) => Promise<void>;
};

export const CollectInfo = ({status, onCtaClick, onClickClose}: RSVPModalVariantABContentProps) => (
  <Step
    header={
      <Header
        onClose={onClickClose}
        title={
          <>
            You are RSVPing <span className={`rsvp-status--${status}`}>{status}</span>
          </>
        }
      />
    }
  >
    <RSVPModalContent
      hideHeader
      doNotRedirect
      onSubmitRSVP={onCtaClick}
      status={status}
      onClose={onClickClose}
    />
  </Step>
);
